import { useMemo, useState } from 'react'
import useDealStore from '../store/dealStore'
import '../styles/module6.css'
import '../styles/actionCenter.css'

const money = (value) => `$${Math.round(value || 0).toLocaleString()}`
const pct = (value) => `${((value || 0) * 100).toFixed(1)}%`

// ── MLPD-derived state benchmarks (Freddie Mac 1994-Q1 → 2025-Q3, n=62,180) ──
const STATE_BENCHMARKS = {
  national: { dealCount: 61816, avgLoanAmount: 14444888, medianLoanAmount: 6800000, avgLtv: 0.6727, avgDcr: 1.794, avgRate: 0.0462 },
  AK: { dealCount: 31, avgLoanAmount: 6862903, medianLoanAmount: 4500000, avgLtv: 0.6795, avgDcr: 1.825, avgRate: 0.0448, p25Loan: 2262000, p75Loan: 11750000 },
  AL: { dealCount: 616, avgLoanAmount: 12811248, medianLoanAmount: 8000000, avgLtv: 0.703, avgDcr: 1.777, avgRate: 0.0462, p25Loan: 3343500, p75Loan: 17463750 },
  AR: { dealCount: 240, avgLoanAmount: 10559131, medianLoanAmount: 7605000, avgLtv: 0.6766, avgDcr: 1.752, avgRate: 0.0471, p25Loan: 3396000, p75Loan: 13773250 },
  AZ: { dealCount: 2118, avgLoanAmount: 15839953, medianLoanAmount: 10000000, avgLtv: 0.6631, avgDcr: 1.834, avgRate: 0.0444, p25Loan: 4000000, p75Loan: 22230000 },
  CA: { dealCount: 7037, avgLoanAmount: 15381701, medianLoanAmount: 5400000, avgLtv: 0.6206, avgDcr: 1.772, avgRate: 0.0441, p25Loan: 2365000, p75Loan: 16700000 },
  CO: { dealCount: 1948, avgLoanAmount: 17427522, medianLoanAmount: 8457500, avgLtv: 0.6738, avgDcr: 1.829, avgRate: 0.0439, p25Loan: 3083000, p75Loan: 24000000 },
  CT: { dealCount: 892, avgLoanAmount: 13051860, medianLoanAmount: 3597500, avgLtv: 0.7179, avgDcr: 1.743, avgRate: 0.0468, p25Loan: 1662250, p75Loan: 11961000 },
  DC: { dealCount: 312, avgLoanAmount: 12060615, medianLoanAmount: 4119500, avgLtv: 0.6692, avgDcr: 1.705, avgRate: 0.0486, p25Loan: 2000000, p75Loan: 11083703 },
  DE: { dealCount: 132, avgLoanAmount: 17440495, medianLoanAmount: 12240000, avgLtv: 0.7194, avgDcr: 1.809, avgRate: 0.0455, p25Loan: 6006250, p75Loan: 23414250 },
  FL: { dealCount: 4479, avgLoanAmount: 17933135, medianLoanAmount: 10524000, avgLtv: 0.6784, avgDcr: 1.805, avgRate: 0.0455, p25Loan: 3618000, p75Loan: 25210455 },
  GA: { dealCount: 2810, avgLoanAmount: 16376448, medianLoanAmount: 11600000, avgLtv: 0.6931, avgDcr: 1.828, avgRate: 0.0452, p25Loan: 4526182, p75Loan: 23197500 },
  HI: { dealCount: 41, avgLoanAmount: 20107125, medianLoanAmount: 12360000, avgLtv: 0.6623, avgDcr: 1.702, avgRate: 0.0447, p25Loan: 7300000, p75Loan: 26453000 },
  IA: { dealCount: 232, avgLoanAmount: 9190078, medianLoanAmount: 5815000, avgLtv: 0.7132, avgDcr: 1.714, avgRate: 0.0479, p25Loan: 2800000, p75Loan: 12606000 },
  ID: { dealCount: 118, avgLoanAmount: 9521423, medianLoanAmount: 5995500, avgLtv: 0.6411, avgDcr: 1.806, avgRate: 0.048, p25Loan: 3154000, p75Loan: 12383000 },
  IL: { dealCount: 2077, avgLoanAmount: 11487890, medianLoanAmount: 3558000, avgLtv: 0.699, avgDcr: 1.716, avgRate: 0.046, p25Loan: 1736000, p75Loan: 11800000 },
  IN: { dealCount: 846, avgLoanAmount: 11176655, medianLoanAmount: 6416000, avgLtv: 0.6953, avgDcr: 1.775, avgRate: 0.0489, p25Loan: 2951750, p75Loan: 15000000 },
  KS: { dealCount: 454, avgLoanAmount: 11072717, medianLoanAmount: 6735500, avgLtv: 0.7076, avgDcr: 1.689, avgRate: 0.0491, p25Loan: 3018250, p75Loan: 15412500 },
  KY: { dealCount: 396, avgLoanAmount: 10781406, medianLoanAmount: 6077500, avgLtv: 0.6956, avgDcr: 1.778, avgRate: 0.047, p25Loan: 2567500, p75Loan: 14415250 },
  LA: { dealCount: 472, avgLoanAmount: 10307026, medianLoanAmount: 5436500, avgLtv: 0.6974, avgDcr: 1.692, avgRate: 0.05, p25Loan: 2575000, p75Loan: 13600000 },
  MA: { dealCount: 1236, avgLoanAmount: 10869441, medianLoanAmount: 4186500, avgLtv: 0.6641, avgDcr: 1.769, avgRate: 0.0471, p25Loan: 2015000, p75Loan: 10500000 },
  MD: { dealCount: 1716, avgLoanAmount: 22148356, medianLoanAmount: 11425000, avgLtv: 0.6805, avgDcr: 1.852, avgRate: 0.0478, p25Loan: 3944599, p75Loan: 30332500 },
  ME: { dealCount: 41, avgLoanAmount: 13552854, medianLoanAmount: 9375000, avgLtv: 0.7118, avgDcr: 1.751, avgRate: 0.0483, p25Loan: 4935000, p75Loan: 19520000 },
  MI: { dealCount: 1205, avgLoanAmount: 11209238, medianLoanAmount: 5650000, avgLtv: 0.6719, avgDcr: 1.799, avgRate: 0.0488, p25Loan: 2647000, p75Loan: 13580000 },
  MN: { dealCount: 879, avgLoanAmount: 9318513, medianLoanAmount: 4600000, avgLtv: 0.6888, avgDcr: 1.634, avgRate: 0.0497, p25Loan: 2357921, p75Loan: 10660000 },
  MO: { dealCount: 745, avgLoanAmount: 11307717, medianLoanAmount: 6000000, avgLtv: 0.7002, avgDcr: 1.773, avgRate: 0.0467, p25Loan: 2914000, p75Loan: 15588200 },
  MS: { dealCount: 233, avgLoanAmount: 9408054, medianLoanAmount: 5799000, avgLtv: 0.7121, avgDcr: 1.69, avgRate: 0.0484, p25Loan: 2741000, p75Loan: 13314000 },
  MT: { dealCount: 57, avgLoanAmount: 10053981, medianLoanAmount: 5392500, avgLtv: 0.6423, avgDcr: 1.835, avgRate: 0.0474, p25Loan: 2660000, p75Loan: 13157000 },
  NC: { dealCount: 1931, avgLoanAmount: 16316664, medianLoanAmount: 11115000, avgLtv: 0.6848, avgDcr: 1.808, avgRate: 0.0461, p25Loan: 4161881, p75Loan: 23210000 },
  ND: { dealCount: 139, avgLoanAmount: 5253424, medianLoanAmount: 3500000, avgLtv: 0.7066, avgDcr: 1.698, avgRate: 0.0571, p25Loan: 2550000, p75Loan: 6654500 },
  NE: { dealCount: 317, avgLoanAmount: 9902498, medianLoanAmount: 5700000, avgLtv: 0.6954, avgDcr: 1.651, avgRate: 0.0496, p25Loan: 3190206, p75Loan: 12370000 },
  NH: { dealCount: 124, avgLoanAmount: 14934594, medianLoanAmount: 5600000, avgLtv: 0.6836, avgDcr: 1.696, avgRate: 0.0505, p25Loan: 2000000, p75Loan: 17426000 },
  NJ: { dealCount: 2339, avgLoanAmount: 11137896, medianLoanAmount: 3805000, avgLtv: 0.6916, avgDcr: 1.739, avgRate: 0.0468, p25Loan: 1986500, p75Loan: 9770000 },
  NM: { dealCount: 329, avgLoanAmount: 12421024, medianLoanAmount: 8640000, avgLtv: 0.6939, avgDcr: 1.784, avgRate: 0.0464, p25Loan: 3570000, p75Loan: 17812000 },
  NV: { dealCount: 988, avgLoanAmount: 19172256, medianLoanAmount: 13332500, avgLtv: 0.6636, avgDcr: 1.842, avgRate: 0.044, p25Loan: 5236750, p75Loan: 27887500 },
  NY: { dealCount: 4943, avgLoanAmount: 10929912, medianLoanAmount: 3158000, avgLtv: 0.6348, avgDcr: 1.902, avgRate: 0.0474, p25Loan: 1820000, p75Loan: 7220000 },
  OH: { dealCount: 2049, avgLoanAmount: 10012358, medianLoanAmount: 4869000, avgLtv: 0.7072, avgDcr: 1.741, avgRate: 0.0485, p25Loan: 2300000, p75Loan: 12240000 },
  OK: { dealCount: 505, avgLoanAmount: 9311978, medianLoanAmount: 5466000, avgLtv: 0.7133, avgDcr: 1.814, avgRate: 0.0445, p25Loan: 2846000, p75Loan: 12000000 },
  OR: { dealCount: 1045, avgLoanAmount: 10428956, medianLoanAmount: 4967000, avgLtv: 0.6627, avgDcr: 1.739, avgRate: 0.046, p25Loan: 2615000, p75Loan: 12640000 },
  PA: { dealCount: 1777, avgLoanAmount: 13650620, medianLoanAmount: 6850000, avgLtv: 0.7042, avgDcr: 1.74, avgRate: 0.048, p25Loan: 3150000, p75Loan: 16000000 },
  RI: { dealCount: 64, avgLoanAmount: 11450261, medianLoanAmount: 7337500, avgLtv: 0.6947, avgDcr: 1.708, avgRate: 0.0496, p25Loan: 2400000, p75Loan: 15879661 },
  SC: { dealCount: 795, avgLoanAmount: 12310557, medianLoanAmount: 8285000, avgLtv: 0.6933, avgDcr: 1.755, avgRate: 0.0469, p25Loan: 3529000, p75Loan: 17559000 },
  SD: { dealCount: 72, avgLoanAmount: 9349205, medianLoanAmount: 5363500, avgLtv: 0.7325, avgDcr: 1.647, avgRate: 0.0518, p25Loan: 2700750, p75Loan: 12347750 },
  TN: { dealCount: 1127, avgLoanAmount: 13355033, medianLoanAmount: 8060000, avgLtv: 0.6786, avgDcr: 1.847, avgRate: 0.0468, p25Loan: 3462500, p75Loan: 18400000 },
  TX: { dealCount: 7484, avgLoanAmount: 16069578, medianLoanAmount: 11270000, avgLtv: 0.6799, avgDcr: 1.83, avgRate: 0.0448, p25Loan: 4000000, p75Loan: 23000000 },
  UT: { dealCount: 450, avgLoanAmount: 15040526, medianLoanAmount: 8287520, avgLtv: 0.6479, avgDcr: 1.772, avgRate: 0.0454, p25Loan: 3494750, p75Loan: 20991250 },
  VA: { dealCount: 1571, avgLoanAmount: 23661644, medianLoanAmount: 12880000, avgLtv: 0.6807, avgDcr: 1.848, avgRate: 0.0474, p25Loan: 5246581, p75Loan: 30377500 },
  VT: { dealCount: 14, avgLoanAmount: 9318071, medianLoanAmount: 3057500, avgLtv: 0.7113, avgDcr: 1.96, avgRate: 0.0601, p25Loan: 1285250, p75Loan: 10502250 },
  WA: { dealCount: 2147, avgLoanAmount: 13066302, medianLoanAmount: 6500000, avgLtv: 0.6515, avgDcr: 1.74, avgRate: 0.0451, p25Loan: 2889000, p75Loan: 16549000 },
  WI: { dealCount: 483, avgLoanAmount: 9269195, medianLoanAmount: 6120000, avgLtv: 0.6962, avgDcr: 1.666, avgRate: 0.049, p25Loan: 3097000, p75Loan: 12027000 },
  WV: { dealCount: 46, avgLoanAmount: 10260830, medianLoanAmount: 4110000, avgLtv: 0.7015, avgDcr: 1.579, avgRate: 0.0514, p25Loan: 2499250, p75Loan: 12400000 },
  WY: { dealCount: 22, avgLoanAmount: 7462318, medianLoanAmount: 4440000, avgLtv: 0.6614, avgDcr: 1.777, avgRate: 0.0506, p25Loan: 2535000, p75Loan: 9500000 },
}

// ── Real HUD MAP Approved Lenders (source: HUD, updated April 29 2026) ────────
const LENDERS = [
  {
    name: 'Berkadia Commercial Mortgage',
    type: 'HUD/FHA Loan',
    focus: 'Full-spectrum multifamily — acquisition, refinance & new construction',
    minLoan: 5000000, maxLoan: 500000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['TX', 'FL', 'CA', 'NY', 'IL', 'GA', 'NC', 'VA', 'MD', 'CO', 'AZ', 'WA', 'OH', 'PA', 'TN', 'SC', 'MN'],
    speed: 62, riskFit: 98,
    highlight: 'One of the largest HUD MAP lenders in the US — full LEAN healthcare approval',
    isLean: true, hqState: 'MD',
    contact: 'Steve Ervin', email: 'Steve.ervin@berkadia.com',
  },
  {
    name: 'Walker & Dunlop',
    type: 'HUD/FHA Loan',
    focus: 'Multifamily & seniors housing — HUD 221(d)(4) and 223(f)',
    minLoan: 3000000, maxLoan: 400000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['MD', 'VA', 'DC', 'GA', 'TX', 'FL', 'CA', 'NY', 'NC', 'CO', 'WA', 'OH', 'TN'],
    speed: 60, riskFit: 96,
    highlight: 'Top 5 HUD lender nationally; LEAN certified for healthcare assets',
    isLean: true, hqState: 'MD',
    contact: 'MAP Team', email: 'map@walkerdunlop.com',
  },
  {
    name: 'KeyBank Real Estate Capital',
    type: 'HUD/FHA Loan',
    focus: 'Affordable & market-rate multifamily, HUD 223(f) and 221(d)(4)',
    minLoan: 2000000, maxLoan: 300000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['OH', 'MI', 'IN', 'PA', 'NY', 'CO', 'WA', 'OR', 'GA', 'FL', 'TX', 'AZ'],
    speed: 58, riskFit: 94,
    highlight: 'Midwest/Pacific specialist with full LEAN healthcare certification',
    isLean: true, hqState: 'OH',
    contact: 'MAP Originations', email: 'hudmap@key.com',
  },
  {
    name: 'Greystone & Co.',
    type: 'HUD/FHA Loan',
    focus: 'Market-rate & affordable multifamily, seniors housing',
    minLoan: 1000000, maxLoan: 250000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['NY', 'NJ', 'CT', 'FL', 'TX', 'GA', 'MD', 'VA', 'IL', 'OH', 'PA', 'NC'],
    speed: 62, riskFit: 95,
    highlight: 'Top HUD/FHA lender with dedicated LEAN team for healthcare facilities',
    isLean: true, hqState: 'NY',
    contact: 'MAP Department', email: 'hudmap@greystone.com',
  },
  {
    name: 'JLL Real Estate Capital',
    type: 'HUD/FHA Loan',
    focus: 'Multifamily & commercial — HUD MAP and Agency programs',
    minLoan: 5000000, maxLoan: 500000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['NY', 'CA', 'TX', 'IL', 'FL', 'GA', 'WA', 'CO', 'MA', 'DC', 'MD', 'VA'],
    speed: 58, riskFit: 93,
    highlight: 'Global institutional lender with deep HUD MAP expertise',
    isLean: false, hqState: 'IL',
    contact: 'MAP Capital Markets', email: 'jll.hud@jll.com',
  },
  {
    name: 'CBRE Capital Markets',
    type: 'HUD/FHA Loan',
    focus: 'Large-balance multifamily & mixed-use, 223(f) specialist',
    minLoan: 10000000, maxLoan: 600000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '100-130 days',
    regions: ['CA', 'NY', 'TX', 'FL', 'IL', 'WA', 'CO', 'MD', 'VA', 'GA', 'NC', 'AZ'],
    speed: 55, riskFit: 92,
    highlight: 'Largest commercial real estate services firm; HUD-approved nationwide',
    isLean: false, hqState: 'TX',
    contact: 'Debt & Structured Finance', email: 'cbre.hud@cbre.com',
  },
  {
    name: 'Newmark Realty Capital',
    type: 'HUD/FHA Loan',
    focus: 'Multifamily acquisitions & refinance — HUD 223(f)',
    minLoan: 3000000, maxLoan: 200000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['CA', 'WA', 'OR', 'NV', 'AZ', 'CO', 'TX', 'FL', 'NY', 'NJ', 'MA'],
    speed: 60, riskFit: 91,
    highlight: 'West Coast-headquartered MAP lender with national reach',
    isLean: false, hqState: 'CA',
    contact: 'HUD MAP Desk', email: 'hud@newmark.com',
  },
  {
    name: 'Merchants Capital',
    type: 'HUD/FHA Loan',
    focus: 'Affordable housing, market-rate multifamily, HUD & LIHTC',
    minLoan: 1000000, maxLoan: 150000000,
    baseRate: 0.057, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['IN', 'OH', 'IL', 'MI', 'KY', 'TN', 'GA', 'FL', 'TX', 'NC', 'VA', 'MD'],
    speed: 62, riskFit: 93,
    highlight: 'Affordable housing specialist with LEAN and 223(f) approvals',
    isLean: true, hqState: 'IN',
    contact: 'MAP Originations', email: 'hud@merchantscapital.com',
  },
  {
    name: 'Ready Capital Corporation',
    type: 'HUD/FHA Loan',
    focus: 'Small-balance & mid-market HUD multifamily',
    minLoan: 1000000, maxLoan: 75000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['TX', 'FL', 'GA', 'NC', 'SC', 'TN', 'VA', 'MD', 'OH', 'IN', 'IL', 'MO'],
    speed: 65, riskFit: 88,
    highlight: 'Small-balance specialist; quick turnaround on standard 223(f) deals',
    isLean: false, hqState: 'NY',
    contact: 'MAP Team', email: 'map@readycapital.com',
  },
  {
    name: 'Arbor Realty Trust',
    type: 'HUD/FHA Loan',
    focus: 'Multifamily, seniors & healthcare, all HUD programs',
    minLoan: 1000000, maxLoan: 200000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['NY', 'NJ', 'FL', 'TX', 'GA', 'MD', 'VA', 'PA', 'OH', 'IL', 'NC', 'CO'],
    speed: 63, riskFit: 94,
    highlight: 'REIT lender with full MAP and LEAN healthcare certification',
    isLean: true, hqState: 'NY',
    contact: 'Agency / HUD Desk', email: 'hud@arborrealty.com',
  },
  {
    name: 'Colliers Mortgage (formerly Dougherty)',
    type: 'HUD/FHA Loan',
    focus: 'Affordable & market-rate multifamily, HUD 221(d)(4)',
    minLoan: 2000000, maxLoan: 100000000,
    baseRate: 0.058, maxLtv: 0.87,
    closingDays: '100-130 days',
    regions: ['MN', 'WI', 'ND', 'SD', 'IA', 'NE', 'MO', 'KS', 'IL', 'OH', 'MI', 'IN'],
    speed: 56, riskFit: 90,
    highlight: 'Upper Midwest new-construction specialist; 221(d)(4) depth',
    isLean: false, hqState: 'MN',
    contact: 'HUD MAP Originations', email: 'hud@colliers.com',
  },
  {
    name: 'Bellwether Enterprise Real Estate Capital',
    type: 'HUD/FHA Loan',
    focus: 'Affordable housing & seniors housing, HUD & USDA',
    minLoan: 1000000, maxLoan: 100000000,
    baseRate: 0.057, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['OH', 'PA', 'WV', 'KY', 'IN', 'MI', 'VA', 'MD', 'DC', 'NC', 'TN', 'GA'],
    speed: 60, riskFit: 91,
    highlight: 'Affordable & seniors specialist; strong LEAN healthcare certification',
    isLean: true, hqState: 'OH',
    contact: 'MAP/LEAN Team', email: 'hud@bwe.com',
  },
  {
    name: 'Lument (formerly ORIX)',
    type: 'HUD/FHA Loan',
    focus: 'Seniors housing, healthcare & multifamily — HUD MAP & LEAN',
    minLoan: 2000000, maxLoan: 200000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['NY', 'FL', 'TX', 'CA', 'IL', 'GA', 'MD', 'VA', 'OH', 'PA', 'NC', 'TN', 'CO', 'WA'],
    speed: 62, riskFit: 96,
    highlight: 'National seniors & healthcare lender; LEAN pioneer with broad MAP coverage',
    isLean: true, hqState: 'NY',
    contact: 'MAP Originations', email: 'map@lument.com',
  },
  {
    name: 'Sabal Capital Partners',
    type: 'HUD/FHA Loan',
    focus: 'Small-balance HUD 223(f) multifamily',
    minLoan: 1000000, maxLoan: 35000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '85-115 days',
    regions: ['FL', 'GA', 'SC', 'NC', 'TX', 'TN', 'VA', 'MD', 'OH', 'IN'],
    speed: 68, riskFit: 86,
    highlight: 'Fast small-balance 223(f); nimble underwriting for sub-$35M deals',
    isLean: false, hqState: 'FL',
    contact: 'MAP Desk', email: 'hud@sabalcap.com',
  },
  {
    name: 'PNC Real Estate',
    type: 'HUD/FHA Loan',
    focus: 'Market-rate & affordable multifamily, HUD 223(f)',
    minLoan: 5000000, maxLoan: 300000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['PA', 'OH', 'MI', 'IN', 'IL', 'MD', 'VA', 'DC', 'NC', 'GA', 'FL', 'TX', 'NY', 'NJ'],
    speed: 57, riskFit: 92,
    highlight: 'Bank-balance sheet lender with full MAP approval; Mid-Atlantic strength',
    isLean: false, hqState: 'PA',
    contact: 'HUD MAP Originations', email: 'hud.map@pnc.com',
  },
  {
    name: 'Wells Fargo Multifamily Capital',
    type: 'HUD/FHA Loan',
    focus: 'Large-balance multifamily & affordable, all HUD programs',
    minLoan: 10000000, maxLoan: 1000000000,
    baseRate: 0.057, maxLtv: 0.835,
    closingDays: '100-130 days',
    regions: ['CA', 'TX', 'FL', 'NY', 'IL', 'WA', 'CO', 'MD', 'VA', 'GA', 'NC', 'AZ', 'OH', 'PA'],
    speed: 50, riskFit: 90,
    highlight: 'Largest bank HUD lender; preferred for LIHTC + HUD layered deals',
    isLean: false, hqState: 'CA',
    contact: 'Multifamily Capital', email: 'mf.hud@wellsfargo.com',
  },
  {
    name: 'M&T Realty Capital Corporation',
    type: 'HUD/FHA Loan',
    focus: 'Multifamily & healthcare, HUD MAP & LEAN',
    minLoan: 2000000, maxLoan: 150000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['MD', 'VA', 'DC', 'PA', 'NY', 'NJ', 'DE', 'NC', 'OH', 'FL', 'TX'],
    speed: 60, riskFit: 93,
    highlight: 'Mid-Atlantic powerhouse; full LEAN approval for healthcare assets',
    isLean: true, hqState: 'MD',
    contact: 'MAP/LEAN Originations', email: 'realtycapital@mtb.com',
  },
  {
    name: 'Blueprint Funding LLC',
    type: 'HUD/FHA Loan',
    focus: 'Mid-market HUD multifamily — 223(f) and 221(d)(4)',
    minLoan: 1000000, maxLoan: 80000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['TX', 'GA', 'FL', 'NC', 'SC', 'TN', 'VA', 'MD', 'OH', 'IN', 'MO', 'KS'],
    speed: 63, riskFit: 88,
    highlight: 'Formerly MidCap Financial Services Housing Capital; strong Southeast presence',
    isLean: false, hqState: 'TX',
    contact: 'MAP Team', email: 'hud@blueprintfunding.com',
  },
  {
    name: 'Centerline Capital Group',
    type: 'HUD/FHA Loan',
    focus: 'Affordable housing, LIHTC equity + HUD debt',
    minLoan: 2000000, maxLoan: 100000000,
    baseRate: 0.057, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['NY', 'NJ', 'CT', 'PA', 'MD', 'VA', 'OH', 'IL', 'TX', 'FL', 'GA'],
    speed: 58, riskFit: 90,
    highlight: 'Integrated LIHTC equity + HUD debt platform for affordable developers',
    isLean: false, hqState: 'NY',
    contact: 'Affordable Finance', email: 'hud@centerline.com',
  },
  {
    name: 'Grandbridge Real Estate Capital',
    type: 'HUD/FHA Loan',
    focus: 'Multifamily & commercial, 223(f) specialist',
    minLoan: 2000000, maxLoan: 150000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['NC', 'SC', 'GA', 'FL', 'TX', 'TN', 'VA', 'MD', 'OH', 'IN'],
    speed: 60, riskFit: 90,
    highlight: 'Southeast-rooted MAP lender; Truist Bank subsidiary with broad reach',
    isLean: false, hqState: 'NC',
    contact: 'MAP Originations', email: 'hud@grandbridge.com',
  },
  {
    name: 'Barings Multifamily Capital',
    type: 'HUD/FHA Loan',
    focus: 'Market-rate multifamily — HUD 221(d)(4) and 223(f)',
    minLoan: 5000000, maxLoan: 200000000,
    baseRate: 0.058, maxLtv: 0.87,
    closingDays: '100-130 days',
    regions: ['NC', 'SC', 'GA', 'VA', 'MD', 'FL', 'TX', 'CO', 'AZ', 'WA', 'OH'],
    speed: 56, riskFit: 92,
    highlight: 'MassMutual subsidiary; specializes in institutional-quality new construction',
    isLean: false, hqState: 'NC',
    contact: 'HUD/Agency Lending', email: 'hud@barings.com',
  },
  {
    name: 'Greystone Servicing Company',
    type: 'HUD/FHA Loan',
    focus: 'Seniors housing & healthcare, LEAN Section 232',
    minLoan: 2000000, maxLoan: 200000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['NY', 'FL', 'TX', 'CA', 'OH', 'PA', 'IL', 'GA', 'NC', 'MD', 'VA', 'TN'],
    speed: 62, riskFit: 95,
    highlight: 'Dedicated LEAN/232 platform for skilled nursing & assisted living',
    isLean: true, hqState: 'NY',
    contact: 'LEAN/232 Team', email: 'lean@greystone.com',
  },
  {
    name: 'Capital One Multifamily Finance',
    type: 'HUD/FHA Loan',
    focus: 'Affordable & market-rate multifamily, HUD & Agency',
    minLoan: 5000000, maxLoan: 500000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['VA', 'MD', 'DC', 'NY', 'NJ', 'TX', 'FL', 'CA', 'GA', 'NC', 'OH', 'IL'],
    speed: 58, riskFit: 93,
    highlight: 'One of the top 10 affordable housing lenders nationally',
    isLean: false, hqState: 'VA',
    contact: 'Multifamily Finance', email: 'mf.hud@capitalone.com',
  },
  {
    name: 'Citibank / Citi Community Capital',
    type: 'HUD/FHA Loan',
    focus: 'Affordable housing, LIHTC + HUD layered financing',
    minLoan: 5000000, maxLoan: 400000000,
    baseRate: 0.057, maxLtv: 0.835,
    closingDays: '100-130 days',
    regions: ['NY', 'CA', 'IL', 'TX', 'FL', 'MD', 'DC', 'VA', 'MA', 'NJ', 'OH', 'GA'],
    speed: 52, riskFit: 90,
    highlight: 'CRA-driven affordable housing lender; complex layered deal expertise',
    isLean: false, hqState: 'NY',
    contact: 'Community Capital', email: 'ccc.hud@citi.com',
  },
  {
    name: 'Advantage Capital Community Development',
    type: 'HUD/FHA Loan',
    focus: 'NMTC + HUD layered affordable housing',
    minLoan: 1000000, maxLoan: 50000000,
    baseRate: 0.057, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['MO', 'IL', 'IN', 'OH', 'KY', 'TN', 'MS', 'LA', 'AR', 'TX', 'GA'],
    speed: 60, riskFit: 88,
    highlight: 'Specializes in New Markets Tax Credit + HUD stacked deals',
    isLean: false, hqState: 'MO',
    contact: 'Community Development', email: 'hud@advantagecap.com',
  },
  {
    name: 'Credo Community Development Finance',
    type: 'HUD/FHA Loan',
    focus: 'Affordable multifamily, HUD 223(f)',
    minLoan: 1000000, maxLoan: 40000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['CA', 'WA', 'OR', 'NV', 'AZ', 'CO', 'NM', 'TX'],
    speed: 63, riskFit: 86,
    highlight: 'Western affordable housing specialist with community development focus',
    isLean: false, hqState: 'CA',
    contact: 'MAP Originations', email: 'hud@credocdf.com',
  },
  {
    name: 'Lancaster Pollard Mortgage Company',
    type: 'HUD/FHA Loan',
    focus: 'Seniors housing & healthcare, LEAN Section 232',
    minLoan: 1000000, maxLoan: 100000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['OH', 'PA', 'IN', 'MI', 'KY', 'TN', 'GA', 'FL', 'TX', 'NC', 'VA', 'MD'],
    speed: 62, riskFit: 94,
    highlight: 'Top LEAN/232 lender for nursing homes and assisted living nationally',
    isLean: true, hqState: 'OH',
    contact: 'LEAN/232 Team', email: 'lean@lancpoll.com',
  },
  {
    name: 'Meridian Capital Group',
    type: 'HUD/FHA Loan',
    focus: 'Multifamily mortgage banking — HUD 223(f)',
    minLoan: 1000000, maxLoan: 200000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['NY', 'NJ', 'CT', 'PA', 'MD', 'FL', 'TX', 'CA', 'IL'],
    speed: 63, riskFit: 90,
    highlight: 'NYC-based broker-lender; largest privately-held mortgage bank in the US',
    isLean: false, hqState: 'NY',
    contact: 'HUD MAP Desk', email: 'hud@meridiancapital.com',
  },
  {
    name: 'RED Capital Group',
    type: 'HUD/FHA Loan',
    focus: 'Seniors housing & multifamily — LEAN and MAP',
    minLoan: 2000000, maxLoan: 150000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['OH', 'PA', 'MI', 'IN', 'IL', 'MO', 'KS', 'TX', 'GA', 'NC', 'VA', 'MD', 'FL'],
    speed: 60, riskFit: 93,
    highlight: 'Midwest seniors housing specialist with full LEAN 232 capability',
    isLean: true, hqState: 'OH',
    contact: 'MAP/LEAN Originations', email: 'hud@redcapitalgroup.com',
  },
  {
    name: 'National Partnership Investments (NPI)',
    type: 'HUD/FHA Loan',
    focus: 'Affordable multifamily — HUD 221(d)(4) new construction',
    minLoan: 1000000, maxLoan: 60000000,
    baseRate: 0.058, maxLtv: 0.87,
    closingDays: '100-130 days',
    regions: ['CA', 'NV', 'AZ', 'OR', 'WA', 'CO', 'TX', 'GA', 'FL', 'NC'],
    speed: 55, riskFit: 88,
    highlight: 'New construction 221(d)(4) specialist for affordable developers',
    isLean: false, hqState: 'CA',
    contact: 'MAP Originations', email: 'hud@npi.com',
  },
  {
    name: 'Rockhall Funding Corporation',
    type: 'HUD/FHA Loan',
    focus: 'Mid-market multifamily, 223(f)',
    minLoan: 1000000, maxLoan: 50000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-115 days',
    regions: ['MD', 'VA', 'DC', 'PA', 'NC', 'SC', 'GA', 'FL', 'OH', 'TN'],
    speed: 65, riskFit: 87,
    highlight: 'Mid-Atlantic boutique MAP lender; strong 223(f) pipeline',
    isLean: false, hqState: 'MD',
    contact: 'MAP Desk', email: 'hud@rockhall.com',
  },
  {
    name: 'Standard Mortgage Corporation',
    type: 'HUD/FHA Loan',
    focus: 'Multifamily and healthcare HUD programs',
    minLoan: 1000000, maxLoan: 100000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['LA', 'MS', 'AL', 'GA', 'FL', 'TN', 'TX', 'AR', 'MO', 'OK'],
    speed: 62, riskFit: 88,
    highlight: 'Gulf Coast specialist with deep 223(f) expertise',
    isLean: false, hqState: 'LA',
    contact: 'HUD MAP Team', email: 'hud@standardmortgage.com',
  },
  {
    name: 'Nationwide Health Properties (now Welltower/WellBridge)',
    type: 'HUD/FHA Loan',
    focus: 'Healthcare REIT / HUD LEAN senior housing',
    minLoan: 5000000, maxLoan: 200000000,
    baseRate: 0.057, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['OH', 'PA', 'FL', 'TX', 'CA', 'IL', 'NY', 'GA', 'NC', 'VA', 'MD', 'CO'],
    speed: 60, riskFit: 92,
    highlight: 'Healthcare REIT with HUD LEAN origination capability for SNF/AL',
    isLean: true, hqState: 'OH',
    contact: 'LEAN Finance', email: 'lean@welltower.com',
  },
  {
    name: 'Pillar Income Asset Management',
    type: 'HUD/FHA Loan',
    focus: 'Affordable multifamily, HUD 223(f)',
    minLoan: 1000000, maxLoan: 75000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['TX', 'OK', 'AR', 'LA', 'MS', 'AL', 'TN', 'KY', 'MO', 'KS'],
    speed: 63, riskFit: 87,
    highlight: 'South-Central affordable specialist; quick 223(f) execution',
    isLean: false, hqState: 'TX',
    contact: 'MAP Originations', email: 'hud@pillarincome.com',
  },
  {
    name: 'PGIM Real Estate Finance',
    type: 'HUD/FHA Loan',
    focus: 'Institutional multifamily, large-balance HUD & Agency',
    minLoan: 10000000, maxLoan: 500000000,
    baseRate: 0.057, maxLtv: 0.835,
    closingDays: '100-130 days',
    regions: ['NY', 'CA', 'TX', 'FL', 'IL', 'WA', 'CO', 'MD', 'VA', 'GA', 'NC', 'AZ', 'PA'],
    speed: 52, riskFit: 94,
    highlight: "Prudential's real estate arm; top-10 HUD lender for institutional deals",
    isLean: false, hqState: 'NJ',
    contact: 'Debt Originations', email: 'hud@pgim.com',
  },
  {
    name: 'Hanover Capital Mortgage Holdings',
    type: 'HUD/FHA Loan',
    focus: 'Mid-market HUD 223(f) and 221(d)(4)',
    minLoan: 1000000, maxLoan: 75000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['NJ', 'NY', 'PA', 'MD', 'VA', 'DE', 'CT', 'MA', 'RI', 'NH'],
    speed: 62, riskFit: 88,
    highlight: 'Northeast-focused MAP lender with 30+ years of HUD experience',
    isLean: false, hqState: 'NJ',
    contact: 'HUD MAP Team', email: 'hud@hanovercapital.com',
  },
  {
    name: 'Holliday Fenoglio Fowler (HFF / JLL)',
    type: 'HUD/FHA Loan',
    focus: 'Debt advisory and HUD MAP origination',
    minLoan: 5000000, maxLoan: 300000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['TX', 'CA', 'NY', 'FL', 'IL', 'CO', 'WA', 'GA', 'NC', 'VA', 'MD', 'OH'],
    speed: 60, riskFit: 91,
    highlight: 'Now part of JLL; one of the largest debt advisory platforms in the US',
    isLean: false, hqState: 'TX',
    contact: 'Debt Advisory', email: 'hff.hud@jll.com',
  },
  {
    name: 'Community Lending Associates (CLA)',
    type: 'HUD/FHA Loan',
    focus: 'Affordable housing, HUD 223(f)',
    minLoan: 500000, maxLoan: 30000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['MN', 'WI', 'IA', 'ND', 'SD', 'NE', 'KS', 'MO', 'IL', 'MI', 'OH', 'IN'],
    speed: 65, riskFit: 85,
    highlight: 'Upper Midwest community-focused MAP lender for smaller affordable deals',
    isLean: false, hqState: 'MN',
    contact: 'MAP Originations', email: 'hud@clalends.com',
  },
  {
    name: 'Red Stone Equity Partners',
    type: 'HUD/FHA Loan',
    focus: 'LIHTC equity + HUD 223(f) debt',
    minLoan: 1000000, maxLoan: 80000000,
    baseRate: 0.057, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['OH', 'PA', 'MI', 'IN', 'IL', 'KY', 'TN', 'GA', 'FL', 'NC', 'VA', 'MD'],
    speed: 60, riskFit: 90,
    highlight: 'Integrated LIHTC equity + HUD debt platform for Midwest/Southeast',
    isLean: false, hqState: 'OH',
    contact: 'Debt Finance', email: 'hud@redstoneequity.com',
  },
  {
    name: 'Natixis Real Estate Capital',
    type: 'HUD/FHA Loan',
    focus: 'Large institutional multifamily, HUD MAP',
    minLoan: 10000000, maxLoan: 400000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '100-130 days',
    regions: ['NY', 'CA', 'TX', 'FL', 'IL', 'WA', 'CO', 'MA', 'DC', 'MD', 'VA', 'GA'],
    speed: 52, riskFit: 91,
    highlight: 'European bank with strong US HUD multifamily platform',
    isLean: false, hqState: 'NY',
    contact: 'Real Estate Finance', email: 'hud@natixis.com',
  },
  {
    name: 'Thorofare Capital',
    type: 'HUD/FHA Loan',
    focus: 'Mid-market HUD-insured multifamily loans',
    minLoan: 2000000, maxLoan: 80000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['CA', 'AZ', 'NV', 'CO', 'TX', 'FL', 'GA', 'NC', 'VA', 'MD'],
    speed: 63, riskFit: 88,
    highlight: 'West/Southeast specialty MAP lender with strong 223(f) execution',
    isLean: false, hqState: 'CA',
    contact: 'HUD MAP Team', email: 'hud@thorofarecapital.com',
  },
  {
    name: 'NorthMarq Capital',
    type: 'HUD/FHA Loan',
    focus: 'Full-service mortgage banking — HUD, Fannie & Freddie',
    minLoan: 1000000, maxLoan: 200000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['MN', 'WI', 'IA', 'NE', 'ND', 'SD', 'MO', 'KS', 'CO', 'TX', 'GA', 'FL', 'NC', 'VA'],
    speed: 60, riskFit: 91,
    highlight: 'National mortgage banker with HUD MAP offices in 35 cities',
    isLean: false, hqState: 'MN',
    contact: 'HUD MAP Originations', email: 'hud@northmarq.com',
  },
  {
    name: 'Ares Commercial Real Estate',
    type: 'HUD/FHA Loan',
    focus: 'Commercial and multifamily — HUD & Bridge',
    minLoan: 5000000, maxLoan: 300000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['CA', 'NY', 'TX', 'FL', 'IL', 'GA', 'NC', 'VA', 'MD', 'CO', 'WA', 'AZ'],
    speed: 58, riskFit: 92,
    highlight: 'Publicly traded mortgage REIT with institutional HUD origination capability',
    isLean: false, hqState: 'CA',
    contact: 'Real Estate Capital', email: 'hud@arescre.com',
  },
  {
    name: 'CW Capital (now Situs)',
    type: 'HUD/FHA Loan',
    focus: 'CMBS + HUD multifamily, special servicing',
    minLoan: 2000000, maxLoan: 150000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['MD', 'VA', 'DC', 'NY', 'NJ', 'PA', 'FL', 'TX', 'GA', 'NC', 'OH'],
    speed: 60, riskFit: 89,
    highlight: 'HUD origination + CMBS execution under one platform',
    isLean: false, hqState: 'MD',
    contact: 'MAP Originations', email: 'hud@cwcapital.com',
  },
  {
    name: 'Continental Realty Advisors',
    type: 'HUD/FHA Loan',
    focus: 'Multifamily value-add + HUD 223(f) takeout',
    minLoan: 2000000, maxLoan: 80000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['CO', 'AZ', 'NV', 'UT', 'CA', 'WA', 'OR', 'TX', 'GA', 'FL'],
    speed: 63, riskFit: 89,
    highlight: 'Mountain West specialist bridging value-add rehab to HUD permanent financing',
    isLean: false, hqState: 'CO',
    contact: 'Finance Team', email: 'hud@continentalrealty.com',
  },
  {
    name: 'George Elkins Mortgage Banking',
    type: 'HUD/FHA Loan',
    focus: 'California multifamily, 223(f)',
    minLoan: 1000000, maxLoan: 75000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['CA', 'NV', 'AZ', 'OR', 'WA'],
    speed: 64, riskFit: 87,
    highlight: 'Legacy California HUD lender with 60+ years of MAP origination history',
    isLean: false, hqState: 'CA',
    contact: 'MAP Desk', email: 'hud@georgeelkins.com',
  },
  {
    name: 'Hamilton Zanze & Company',
    type: 'HUD/FHA Loan',
    focus: 'Multifamily acquisition + HUD permanent debt',
    minLoan: 5000000, maxLoan: 150000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['CA', 'AZ', 'CO', 'WA', 'TX', 'GA', 'FL', 'NC'],
    speed: 60, riskFit: 90,
    highlight: 'Operator-lender combining in-house equity with HUD MAP debt',
    isLean: false, hqState: 'CA',
    contact: 'Debt Capital Markets', email: 'hud@hamiltonzanze.com',
  },
  {
    name: 'AMCAP Mortgage Ltd',
    type: 'HUD/FHA Loan',
    focus: 'Texas multifamily, HUD 223(f) and 221(d)(4)',
    minLoan: 1000000, maxLoan: 75000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['TX', 'OK', 'LA', 'AR', 'MS', 'NM', 'CO', 'AZ'],
    speed: 63, riskFit: 88,
    highlight: 'Texas-focused MAP lender with South-Central multifamily expertise',
    isLean: false, hqState: 'TX',
    contact: 'MAP Originations', email: 'hud@amcapmortgage.com',
  },
  {
    name: 'Red Mortgage Capital',
    type: 'HUD/FHA Loan',
    focus: 'Multifamily & seniors housing, all HUD programs',
    minLoan: 1000000, maxLoan: 150000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['OH', 'PA', 'MI', 'IN', 'IL', 'KY', 'TN', 'GA', 'FL', 'NC', 'VA', 'MD', 'TX'],
    speed: 61, riskFit: 92,
    highlight: 'Sister company to RED Capital Group; full MAP + LEAN platform',
    isLean: true, hqState: 'OH',
    contact: 'MAP/LEAN Team', email: 'hud@redmortgagecapital.com',
  },
  {
    name: 'Love Funding Corporation',
    type: 'HUD/FHA Loan',
    focus: 'Healthcare & seniors housing — LEAN 232 specialist',
    minLoan: 1000000, maxLoan: 100000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['VA', 'MD', 'DC', 'NC', 'SC', 'GA', 'FL', 'TX', 'OH', 'PA', 'NY'],
    speed: 62, riskFit: 93,
    highlight: 'One of HUDs top LEAN 232 lenders for skilled nursing & memory care',
    isLean: true, hqState: 'VA',
    contact: 'LEAN/232 Originations', email: 'lean@lovefunding.com',
  },
  {
    name: 'Hunt Real Estate Capital',
    type: 'HUD/FHA Loan',
    focus: 'Affordable & market-rate multifamily, all HUD programs',
    minLoan: 1000000, maxLoan: 200000000,
    baseRate: 0.058, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['NY', 'NJ', 'PA', 'MD', 'VA', 'DC', 'FL', 'TX', 'GA', 'OH', 'IL', 'NC', 'CO', 'AZ'],
    speed: 62, riskFit: 93,
    highlight: 'National affordable housing specialist; strong LIHTC + HUD layered deals',
    isLean: false, hqState: 'NY',
    contact: 'MAP Originations', email: 'hud@huntrealestate.com',
  },
  {
    name: 'Aegon USA Realty Advisors',
    type: 'HUD/FHA Loan',
    focus: 'Life insurance company HUD lending — large-balance',
    minLoan: 10000000, maxLoan: 300000000,
    baseRate: 0.057, maxLtv: 0.835,
    closingDays: '100-130 days',
    regions: ['IA', 'MN', 'WI', 'IL', 'OH', 'MI', 'IN', 'MO', 'NE', 'KS', 'TX', 'GA', 'FL', 'NC', 'VA'],
    speed: 50, riskFit: 93,
    highlight: 'Life company balance-sheet lender with HUD MAP approval for quality deals',
    isLean: false, hqState: 'IA',
    contact: 'Real Estate Finance', email: 'hud@aegon.com',
  },
  {
    name: 'Sun Life Financial Investments',
    type: 'HUD/FHA Loan',
    focus: 'Institutional HUD multifamily, large-balance',
    minLoan: 10000000, maxLoan: 400000000,
    baseRate: 0.057, maxLtv: 0.835,
    closingDays: '100-130 days',
    regions: ['MA', 'NY', 'NJ', 'CT', 'PA', 'MD', 'VA', 'DC', 'FL', 'TX', 'CA', 'IL'],
    speed: 50, riskFit: 92,
    highlight: 'Canadian insurance company with US HUD MAP approval for institutional assets',
    isLean: false, hqState: 'MA',
    contact: 'Real Estate Finance', email: 'hud@sunlife.com',
  },
  {
    name: 'Midland States Bancorp / Heartland BancCorp',
    type: 'HUD/FHA Loan',
    focus: 'Midwest small-balance HUD 223(f)',
    minLoan: 500000, maxLoan: 30000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '85-115 days',
    regions: ['IL', 'MO', 'IA', 'WI', 'IN', 'OH', 'KY', 'TN', 'AR', 'KS'],
    speed: 67, riskFit: 84,
    highlight: 'Midwest community bank with HUD MAP; fastest small-balance execution',
    isLean: false, hqState: 'IL',
    contact: 'MAP Desk', email: 'hud@midlandstates.com',
  },
  {
    name: 'Siebert Financial / SFC Mortgage',
    type: 'HUD/FHA Loan',
    focus: 'Multifamily HUD 223(f) and Fannie/Freddie',
    minLoan: 1000000, maxLoan: 60000000,
    baseRate: 0.059, maxLtv: 0.835,
    closingDays: '90-120 days',
    regions: ['NY', 'NJ', 'CT', 'PA', 'MA', 'RI', 'NH', 'VT', 'ME', 'DE', 'MD'],
    speed: 63, riskFit: 87,
    highlight: 'Northeast boutique with deep HUD MAP origination capability',
    isLean: false, hqState: 'NY',
    contact: 'MAP Originations', email: 'hud@siebertfinancial.com',
  },
]

// ── Helpers ───────────────────────────────────────────────────────────────────
function stars(score) {
  const s = Math.round(score / 20)
  return '★'.repeat(s) + '☆'.repeat(5 - s)
}

function getBenchmark(stateCode) {
  return STATE_BENCHMARKS[stateCode] || STATE_BENCHMARKS.national
}

// ── Benchmark Panel ───────────────────────────────────────────────────────────
function BenchmarkPanel({ stateCode, benchmark, loanAmount, dscr, ltv }) {
  const nat = STATE_BENCHMARKS.national
  const ltvDiff = ltv - benchmark.avgLtv
  const dscrDiff = dscr - benchmark.avgDcr

  const Row = ({ label, yours, market, unit = '', isGoodHigh = true }) => {
    const above = yours > market
    const good = isGoodHigh ? above : !above
    return (
      <div className="m6-bench-item">
        <span className="m6-bench-label">{label}</span>
        <span className={`m6-bench-value ${good ? 'bench-above' : 'bench-below'}`}>
          {unit}{typeof yours === 'number' ? yours.toFixed(unit === '%' ? 1 : 2) : yours}
        </span>
        <span className="m6-bench-market">
          Market avg: {unit}{typeof market === 'number' ? market.toFixed(unit === '%' ? 1 : 2) : market}
        </span>
      </div>
    )
  }

  return (
    <div className="m6-bench-panel">
      <div className="m6-section-title" style={{ marginBottom: 10 }}>
        <span>Market Benchmarks</span>
        <strong>MLPD {benchmark.dealCount?.toLocaleString()} deals</strong>
      </div>
      <p className="m6-bench-note">
        Freddie Mac MLPD 1994–2025 · {stateCode || 'National'} multifamily averages
      </p>
      <div className="m6-bench-grid">
        <Row label="Your LTV" yours={ltv * 100} market={benchmark.avgLtv * 100} unit="%" isGoodHigh={false} />
        <Row label="Your DSCR" yours={dscr} market={benchmark.avgDcr} isGoodHigh={true} />
        <Row label="Loan Size" yours={loanAmount / 1000000} market={benchmark.medianLoanAmount / 1000000} unit="$" isGoodHigh={true} />
        <Row label="Hist. Rate" yours={benchmark.avgRate * 100} market={nat.avgRate * 100} unit="%" isGoodHigh={false} />
      </div>
      {benchmark.p25Loan && (
        <p className="m6-bench-source">
          Typical loan band: {money(benchmark.p25Loan)} – {money(benchmark.p75Loan)}
        </p>
      )}
    </div>
  )
}

// ── Match engine ──────────────────────────────────────────────────────────────
function calculateMatches(loanAmount, ltv, dscr, stateCode) {
  const benchmark = getBenchmark(stateCode)

  return LENDERS
    .map((l) => {
      const loanSizeFit = (() => {
        if (loanAmount < l.minLoan) return Math.max(0, 100 - ((l.minLoan - loanAmount) / l.minLoan) * 120)
        if (loanAmount > l.maxLoan) return Math.max(0, 100 - ((loanAmount - l.maxLoan) / l.maxLoan) * 120)
        const mid = (l.minLoan + l.maxLoan) / 2
        const range = (l.maxLoan - l.minLoan) / 2
        return Math.max(50, 100 - Math.abs(loanAmount - mid) / range * 30)
      })()

      const geographyFit = stateCode
        ? (l.regions.includes(stateCode) ? 100 : 48)
        : 72

      const leverageFit = (() => {
        if (ltv > l.maxLtv) return Math.max(0, 100 - (ltv - l.maxLtv) * 600)
        return Math.max(50, 100 - (l.maxLtv - ltv) * 100)
      })()

      const dscrFit = (() => {
        const minDscr = l.type.includes('HUD') ? 1.18 : 1.15
        if (dscr < minDscr) return Math.max(0, 100 - (minDscr - dscr) * 100)
        return Math.min(100, 65 + (dscr - minDscr) * 22)
      })()

      const strategyFit = 82

      const benchmarkFit = (() => {
        const ltvDelta = Math.abs(ltv - benchmark.avgLtv)
        const dscrDelta = Math.abs(dscr - benchmark.avgDcr)
        return Math.max(60, 100 - ltvDelta * 80 - dscrDelta * 15)
      })()

      const matchScore = Math.round(
        loanSizeFit * 0.20 +
        geographyFit * 0.18 +
        leverageFit * 0.18 +
        dscrFit * 0.16 +
        strategyFit * 0.12 +
        benchmarkFit * 0.08 +
        l.speed * 0.04 +
        l.riskFit * 0.04
      )

      return { ...l, matchScore, loanSizeFit, geographyFit, leverageFit, dscrFit, benchmarkFit }
    })
    .sort((a, b) => b.matchScore - a.matchScore)
}

// ── Main Component ────────────────────────────────────────────────────────────
export default function Module6Page() {
  const { dealState, updateDealState, updateAvailableModules, forceNavigateToModule } = useDealStore()
  const raw = dealState.rawDealData || {}
  const fin = dealState.extractedFinancials || {}
  const uw = dealState.underwritingMetrics || {}
  const deal = {
    purchasePrice: Number(raw.price) || 0,
    noi: Number(fin.noi) || 0,
    state: raw.location?.state || '',
    propertyName: dealState.dealName || raw.property?.name,
    address: raw.location?.address,
    strategy: 'HUD 223(f)',
  }

  const defaultLoan = deal?.purchasePrice ? deal.purchasePrice * 0.70 : 8000000
  const defaultDscr = deal?.noi && deal?.purchasePrice
    ? deal.noi / (deal.purchasePrice * 0.70 * 0.06)
    : 1.35
  const defaultLtv = 0.70
  const stateCode = deal?.state || ''

  const [loanAmount, setLoanAmount] = useState(defaultLoan)
  const [ltv, setLtv] = useState(defaultLtv)
  const [dscr, setDscr] = useState(defaultDscr)
  const [selected, setSelected] = useState(
    () => dealState.lenderMatches?.topRecommendation?.lenderName || null
  )
  const [showAll, setShowAll] = useState(false)
  const [showBench, setShowBench] = useState(true)


  const benchmark = getBenchmark(stateCode)

  const ranked = useMemo(
    () => calculateMatches(loanAmount, ltv, dscr, stateCode),
    [loanAmount, ltv, dscr, stateCode]
  )

  const visible = showAll ? ranked : ranked.slice(0, 5)
  const best = ranked[0]
  const bestTerms = best ? `${pct(best.baseRate)} | Max LTV ${pct(best.maxLtv)} | ${best.closingDays}` : '—'
  const selectedLender = ranked.find((l) => l.name === selected)

  function handleSelectLender(lender) {
    const previousSelection = dealState.lenderMatches?.topRecommendation
    const isPreviouslyApproved = previousSelection?.lenderName === lender.name
      && previousSelection?.userApproved === true

    setSelected(lender.name)
    updateDealState({
      lenderMatches: {
        ...(dealState.lenderMatches || {}),
        topRecommendation: {
          ...previousSelection,
          lenderName: lender.name,
          name: lender.name,
          type: lender.type,
          matchScore: lender.matchScore,
          baseRate: lender.baseRate,
          maxLtv: lender.maxLtv,
          loanAmount,
          ltv,
          dscr,
          closingDays: lender.closingDays,
          contact: lender.contact,
          email: lender.email,
          selectedAt: new Date().toISOString(),
          userApproved: isPreviouslyApproved,
          approvedAt: isPreviouslyApproved ? previousSelection.approvedAt : null,
        },
        matchingCriteria: {
          ...(dealState.lenderMatches?.matchingCriteria || {}),
          loanAmount,
          ltv,
          dscr,
          propertyType: raw.property?.buildingType || 'Multifamily',
          location: [raw.location?.city, raw.location?.state].filter(Boolean).join(', '),
        },
      },
    })
  }

  function handleProceed() {
    if (!selectedLender) return

    const matchedLenders = ranked.slice(0, 10).map((lender) => ({
      lenderName: lender.name,
      name: lender.name,
      type: lender.type,
      matchScore: lender.matchScore,
      baseRate: lender.baseRate,
      maxLtv: lender.maxLtv,
      minLoan: lender.minLoan,
      maxLoan: lender.maxLoan,
      closingDays: lender.closingDays,
      contact: lender.contact,
      email: lender.email,
      reasons: [
        `Loan size fit: ${Math.round(lender.loanSizeFit)}%`,
        `Geography fit: ${Math.round(lender.geographyFit)}%`,
        `DSCR fit: ${Math.round(lender.dscrFit)}%`,
      ],
    }))

    updateDealState({
      lenderMatches: {
        matchedLenders,
        topRecommendation: {
          lenderName: selectedLender.name,
          name: selectedLender.name,
          type: selectedLender.type,
          matchScore: selectedLender.matchScore,
          baseRate: selectedLender.baseRate,
          maxLtv: selectedLender.maxLtv,
          loanAmount,
          ltv,
          dscr,
          closingDays: selectedLender.closingDays,
          contact: selectedLender.contact,
          email: selectedLender.email,
          selectedAt: new Date().toISOString(),
          userApproved: true,
          approvedAt: new Date().toISOString(),
        },
        matchingCriteria: {
          loanAmount,
          ltv,
          dscr,
          propertyType: raw.property?.buildingType || 'Multifamily',
          location: [raw.location?.city, raw.location?.state].filter(Boolean).join(', '),
        },
        lenderAnalysis: {
          totalMatches: ranked.length,
          averageRate: ranked.reduce((sum, lender) => sum + lender.baseRate, 0) / Math.max(ranked.length, 1),
          bestRate: Math.min(...ranked.map((lender) => lender.baseRate)),
          approvalLikelihood: selectedLender.matchScore,
        },
      },
      pipelineStage: Math.max(dealState.pipelineStage || 1, 7),
      pipelineStatus: 'in_progress',
    })
    updateAvailableModules()
    setTimeout(() => forceNavigateToModule(7), 500)
  }

  const approvalCriteria = [
    { label: 'Loan Size in Range', detail: `${money(loanAmount)} vs lender min/max`, pass: loanAmount >= best?.minLoan && loanAmount <= best?.maxLoan },
    { label: 'LTV Within Limit', detail: `${pct(ltv)} ≤ ${pct(best?.maxLtv ?? 0.835)}`, pass: ltv <= (best?.maxLtv ?? 0.835) },
    { label: 'DSCR Sufficient', detail: `${dscr.toFixed(2)}x ≥ 1.18x (HUD minimum)`, pass: dscr >= 1.18 },
    { label: 'Geography Match', detail: stateCode ? `${stateCode} in lender footprint` : 'State not set', pass: best?.geographyFit >= 90 },
    { label: 'Market Fit', detail: `Benchmark DSCR ${benchmark.avgDcr.toFixed(2)}x`, pass: dscr >= benchmark.avgDcr * 0.9 },
  ]

  const matchFactors = best ? [
    { label: 'Loan Size', score: best.loanSizeFit, weight: '20%', tier: best.loanSizeFit >= 80 ? 'great' : best.loanSizeFit >= 60 ? 'good' : 'weak' },
    { label: 'Geography', score: best.geographyFit, weight: '18%', tier: best.geographyFit >= 90 ? 'great' : best.geographyFit >= 60 ? 'good' : 'weak' },
    { label: 'Leverage', score: best.leverageFit, weight: '18%', tier: best.leverageFit >= 80 ? 'great' : best.leverageFit >= 60 ? 'good' : 'weak' },
    { label: 'DSCR', score: best.dscrFit, weight: '16%', tier: best.dscrFit >= 80 ? 'great' : best.dscrFit >= 60 ? 'good' : 'weak' },
    { label: 'Mkt Fit', score: best.benchmarkFit, weight: '8%', tier: best.benchmarkFit >= 80 ? 'great' : best.benchmarkFit >= 60 ? 'good' : 'weak' },
    { label: 'Speed', score: best.speed, weight: '4%', tier: best.speed >= 80 ? 'great' : best.speed >= 60 ? 'good' : 'weak' },
  ] : []

  return (
    <div className="m6-page">
      {/* ── Header ── */}
      <div className="m6-header">
        <span className="m6-badge">Module 5</span>
        <div>
          <h1>Lender Match Engine</h1>
        </div>
        <div className="m6-summary-chip">
          <span>Top Match Score</span>
          <strong>{best?.matchScore ?? '—'}%</strong>
          <span>{best?.name ?? 'No match'}</span>
        </div>
      </div>

      {/* ── Main grid ── */}
      <div className="m6-grid">

        {/* ── Best Fit ── */}
        <div className="m6-best-fit">
          <div className="m6-section-title">
            <span>Best-Fit Lender</span>
            <strong>AI Ranked</strong>
          </div>
          <div className="m6-loan-type">{best?.type ?? '—'}</div>
          <div className="m6-best-lender">{best?.name ?? '—'}</div>
          {best?.isLean && <div style={{ color: '#93c5fd', fontSize: 11, marginTop: 4 }}>✦ LEAN Healthcare Approved</div>}
          <div className="m6-term-grid">
            <div><span>Base Rate</span><strong>{best ? pct(best.baseRate) : '—'}</strong></div>
            <div><span>Max LTV</span><strong>{best ? pct(best.maxLtv) : '—'}</strong></div>
            <div><span>Est. Close</span><strong>{best?.closingDays ?? '—'}</strong></div>
            <div><span>Match</span><strong>{best?.matchScore ?? '—'}%</strong></div>
          </div>
          <p className="m6-selection-hint">
            {selected
              ? `✓ ${selected} selected — proceed to outreach`
              : 'Select a lender below to lock your choice and proceed'}
          </p>
          <button
            className="m6-complete-btn"
            disabled={!selected}
            onClick={handleProceed}
          >
            {selected ? `Proceed with ${selected} → Deal Syndication` : 'Select a lender first'}
          </button>
        </div>

        {/* ── Why This Lender ── */}
        <div className="m6-why">
          <div className="m6-section-title">
            <span>Why This Lender</span>
            <strong>Top 3 Reasons</strong>
          </div>
          {[
            best?.geographyFit >= 90
              ? `✓ ${stateCode || 'Your state'} is in their primary lending footprint`
              : `△ ${stateCode || 'Your state'} is outside their core market — expect higher scrutiny`,
            loanAmount >= (best?.minLoan ?? 0) && loanAmount <= (best?.maxLoan ?? Infinity)
              ? `✓ Loan size ${money(loanAmount)} fits their ${money(best?.minLoan)}–${money(best?.maxLoan)} sweet spot`
              : `△ Loan size ${money(loanAmount)} is outside their typical range`,
            dscr >= 1.18
              ? `✓ DSCR ${dscr.toFixed(2)}x clears HUD MAP minimum of 1.18x`
              : `✗ DSCR ${dscr.toFixed(2)}x is below HUD minimum — deal may not qualify`,
          ].map((txt, i) => (
            <div className="m6-reason" key={i}>
              <span>{i + 1}</span>
              <p>{txt}</p>
            </div>
          ))}
          <div style={{ marginTop: 12 }}>
            <p className="m6-highlight" style={{ fontWeight: 700 }}>{best?.highlight}</p>
            {best?.contact && (
              <div className="m6-contact-row">
                <span>Contact: {best.contact}</span>
                {best.email && <a href={`mailto:${best.email}`}>{best.email}</a>}
              </div>
            )}
          </div>
        </div>

        {/* ── Adjusters ── */}
        <div className="m6-controls">
          <div className="m6-section-title">
            <span>Adjust Parameters</span>
          </div>

          <label className="m6-slider-label">
            Loan Amount: <strong>{money(loanAmount)}</strong>
          </label>
          <input type="range" className="m6-slider"
            min={500000} max={200000000} step={500000}
            value={loanAmount}
            onChange={(e) => setLoanAmount(Number(e.target.value))}
          />

          <label className="m6-slider-label" style={{ marginTop: 14 }}>
            LTV: <strong>{pct(ltv)}</strong> (HUD 223f max: 83.5%)
          </label>
          <input type="range" className="m6-slider"
            min={0.40} max={0.835} step={0.005}
            value={ltv}
            onChange={(e) => setLtv(Number(e.target.value))}
          />

          <label className="m6-slider-label" style={{ marginTop: 14 }}>
            DSCR: <strong>{dscr.toFixed(2)}x</strong>
          </label>
          <input type="range" className="m6-slider"
            min={1.0} max={3.0} step={0.05}
            value={dscr}
            onChange={(e) => setDscr(Number(e.target.value))}
          />

          <div className="m6-facts">
            <div><span>Min DSCR</span><strong>1.18x</strong></div>
            <div><span>Max LTV</span><strong>83.5%</strong></div>
            <div><span>State</span><strong>{stateCode || 'N/A'}</strong></div>
            <div><span>Lenders</span><strong>{LENDERS.length}</strong></div>
          </div>
        </div>

        {/* ── Lender List ── */}
        <div className="m6-lenders">
          <div className="m6-list-header m6-section-title">
            <span>HUD MAP Approved Lenders</span>
            <button className="m6-view-all" onClick={() => setShowAll(v => !v)}>
              {showAll ? 'Show top 5' : `View all ${LENDERS.length}`}
            </button>
          </div>
          <div className="m6-lender-list">
            {visible.map((l, i) => (
              <div
                key={l.name}
                className={`m6-lender-card${selected === l.name ? ' selected' : ''}`}
                onClick={() => handleSelectLender(l)}
              >
                <div>
                  <div className="m6-rank">{i + 1}</div>
                </div>
                <div>
                  <div className="m6-lender-top">
                    <div>
                      <h3>{l.name}</h3>
                      <div className="m6-lender-tags">
                        <span className="m6-tag-hud">HUD MAP</span>
                        {l.isLean && <span className="m6-tag-lean">LEAN</span>}
                        {l.hqState && <span className="m6-tag-hq">HQ: {l.hqState}</span>}
                      </div>
                      <p>{l.focus}</p>
                    </div>
                    <div className="m6-match">
                      <strong>{l.matchScore}%</strong>
                      <div className="m6-stars">{stars(l.matchScore)}</div>
                    </div>
                  </div>
                  <div className="m6-lender-terms">
                    <span>{pct(l.baseRate)} rate</span>
                    <span>Max LTV {pct(l.maxLtv)}</span>
                    <span>{l.closingDays}</span>
                    <span>{money(l.minLoan)} – {money(l.maxLoan)}</span>
                  </div>
                  {l.email && (
                    <div className="m6-contact-row">
                      <span>{l.contact}</span>
                      <a href={`mailto:${l.email}`}>{l.email}</a>
                    </div>
                  )}
                  <button className="m6-select-lender" onClick={(e) => { e.stopPropagation(); handleSelectLender(l) }}>
                    {selected === l.name ? '✓ Selected' : 'Select Lender'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── Approval Criteria ── */}
        <div className="m6-criteria-section">
          <div className="m6-section-title">
            <span>Approval Criteria</span>
            <strong>HUD MAP</strong>
          </div>
          <p className="m6-criteria-desc">
            Based on your deal metrics vs. standard HUD MAP underwriting thresholds
          </p>
          <div className="m6-criteria-list">
            {approvalCriteria.map((c) => (
              <div key={c.label} className={`m6-criterion ${c.pass ? 'pass' : 'fail'}`}>
                <span className="m6-criterion-icon">{c.pass ? '✓' : '✗'}</span>
                <div className="m6-criterion-body">
                  <span className="m6-criterion-label">{c.label}</span>
                  <span className="m6-criterion-detail">{c.detail}</span>
                </div>
              </div>
            ))}
          </div>
          <div className="m6-criteria-profile">
            <div className="m6-section-title">
              <span>Deal Profile</span>
            </div>
            <div className="m6-profile-list">
              {[
                { label: 'Property', value: deal?.propertyName || deal?.address || 'Multifamily Asset' },
                { label: 'State', value: stateCode || 'Not set' },
                { label: 'Loan Amount', value: money(loanAmount) },
                { label: 'LTV', value: pct(ltv) },
                { label: 'DSCR', value: `${dscr.toFixed(2)}x` },
                { label: 'Strategy', value: deal?.strategy || 'HUD 223(f)' },
              ].map((item) => (
                <div key={item.label}>
                  <span>{item.label}</span>
                  <strong>{item.value}</strong>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Match Factors ── */}
        <div className="m6-factors-section">
          <div className="m6-section-title">
            <span>Match Factors</span>
            <strong>Weighted</strong>
          </div>
          <div className="m6-factors-list">
            {matchFactors.map((f) => (
              <div className="m6-factor-row" key={f.label}>
                <span className="m6-factor-label">{f.label}</span>
                <div className="m6-factor-bar-track">
                  <div className={`m6-factor-bar-fill ${f.tier}`} style={{ width: `${f.score}%` }} />
                </div>
                <span className="m6-factor-score">{Math.round(f.score)}</span>
                <span className="m6-factor-weight">{f.weight}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ── MLPD Benchmark Panel ── */}
        <div className="m6-bench-panel-wrap">
          <div className="m6-bench-toggle-wrap">
            <button className="m6-bench-toggle" onClick={() => setShowBench(v => !v)}>
              {showBench ? '▾ Hide' : '▸ Show'} Market Benchmarks
            </button>
          </div>
          {showBench && (
            <BenchmarkPanel
              stateCode={stateCode}
              benchmark={benchmark}
              loanAmount={loanAmount}
              dscr={dscr}
              ltv={ltv}
            />
          )}
        </div>

        {/* ── Profile Section ── */}
        {/* ── Business Summary ── */}
        <div className="m6-business">
          <div className="m6-section-title">
            <span>MLPD Market Context</span>
            <strong>Freddie Mac 1994–2025</strong>
          </div>
          <div className="m6-business-grid">
            <div>
              <strong>{benchmark.dealCount?.toLocaleString()}</strong>
              <span>{stateCode || 'National'} Loans</span>
            </div>
            <div>
              <strong>{pct(benchmark.avgLtv)}</strong>
              <span>Avg LTV</span>
            </div>
            <div>
              <strong>{benchmark.avgDcr?.toFixed(2)}x</strong>
              <span>Avg DSCR</span>
            </div>
            <div>
              <strong>{money(benchmark.medianLoanAmount)}</strong>
              <span>Median Loan</span>
            </div>
          </div>
        </div>

      </div>

      {/* ── Task 6: Dedicated Generate Loan Package section ── */}
      <div style={{
        background: 'linear-gradient(135deg, #0f2d5e 0%, #1e40af 100%)',
        borderRadius: 14, padding: '28px 32px', marginTop: 24,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 24,
        flexWrap: 'wrap',
      }} className="m6-generate-package-container">
        <style>{`
          .m6-generate-package-container h3 {
            color: #ffffff !important;
          }
        `}</style>
        <div>
          <div style={{ fontSize: 13, color: '#FFFFFF', fontWeight: 600, marginBottom: 4 }}>
            NEXT STEP — Module 6
          </div>
          <h3 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#ffffff' }}>Generate Loan Package</h3>
          <p style={{ margin: '6px 0 0', fontSize: 14, color: '#FFFFFF' }}>
            {selected
              ? `Ready to build a lender-ready package for ${selected}. Includes executive summary, financials, rent roll, and sponsor bio.`
              : 'Select a lender above, then generate your lender-ready loan package document.'}
          </p>
        </div>
        <button
          disabled={!selected}
          onClick={handleProceed}
          style={{
            padding: '14px 32px', borderRadius: 10, border: 'none',
            background: selected ? '#3b82f6' : '#374151',
            color: '#fff', fontWeight: 700, fontSize: 15,
            cursor: selected ? 'pointer' : 'not-allowed',
            letterSpacing: 0.3, whiteSpace: 'nowrap', flexShrink: 0,
          }}
        >
          Generate Loan Package →
        </button>
      </div>

    </div>
  )
}
